var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNitroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 24 24",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 6C11.6863 6 9 8.68629 9 12C9 15.3137 11.6863 18 15 18C18.3137 18 21 15.3137 21 12C21 8.68629 18.3137 6 15 6ZM7 12C7 7.58172 10.5817 4 15 4C19.4183 4 23 7.58172 23 12C23 16.4183 19.4183 20 15 20C10.5817 20 7 16.4183 7 12Z",
    fill: "white",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6 4H15V6H6V4Z",
    fill: "white",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M5.5 7.5H8.5V9.5H5.5V7.5Z",
    fill: "white",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M2 7.5H3.5V9.5H2V7.5Z",
    fill: "white",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M4 11.5H8V13.5H4V11.5Z",
    fill: "white",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M12.1679 8.4453C12.3534 8.1671 12.6656 8 13 8H17C17.3344 8 17.6466 8.1671 17.8321 8.4453L19.8321 11.4453C20.056 11.7812 20.056 12.2188 19.8321 12.5547L17.8321 15.5547C17.6466 15.8329 17.3344 16 17 16H13C12.6656 16 12.3534 15.8329 12.1679 15.5547L10.1679 12.5547C9.94402 12.2188 9.94402 11.7812 10.1679 11.4453L12.1679 8.4453ZM13.5352 10L12.2019 12L13.5352 14H16.4648L17.7981 12L16.4648 10H13.5352Z",
    fill: "white",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitroIcon);
export default __webpack_public_path__ + "static/media/nitro_icon.e406823f7af477f89ebf88ccf0c09482.svg";
export { ForwardRef as ReactComponent };